import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox } from "devextreme-react/check-box";
import { TextArea } from "devextreme-react/text-area";
import { FileUploader } from "devextreme-react/file-uploader";
import { Button } from "devextreme-react/button";
import QCP_API from "api/qcpApi";
import { Toast } from "devextreme-react/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFetch, usePost, usePostFormData } from "@hooks/useQcpApi";
import "@common-components/cards/DarkCard.scss";
import { RadioGroup } from "devextreme-react";
import { qcpSchemaTest1, qcpSchemaTest2 } from "./qcpSchema";

export default function QCPForm() {
  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded file objects with statuses
  const [comments, setComments] = useState([]); // Store comments
  const [newComment, setNewComment] = useState(""); // Track input
  const qcpMutation = usePost("addinspect", QCP_API.addQcpData);
  const imageUploadMutation = usePostFormData("uploadImages", QCP_API.addImage); // Use usePostFormData
  const fileUploadMutation = usePostFormData("uploadFiles", QCP_API.addFiles); // Use usePostFormData
  const [count, setCount] = useState(0);
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const commentsMutation = usePost("commentsAdd", QCP_API.addComment); // Use usePostFormData

  const [visible, setVisible] = useState(false); // Default visible
  const [toastType, setToastType] = useState("error"); // Default error
  const [toastMessage, setToastMessage] = useState(""); // Default message
  const { data: approvedBY, loading: loadingApprove } = useFetch(
    "approvedbyget",
    QCP_API.approvedBy
  );
  const [loading, setLoading] = useState(false); // Add loading state

  const { data: qcpStatus, loading: isqcpStatusLoading } = useFetch(
    "getQCPStatus",
    QCP_API.getQCPStatus
  );

  const currentDate = new Date().toISOString(); // Store ISO format for consistency

  const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setVisible(true);
  };
  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      const currentDate = new Date().toISOString(); // Store ISO format for consistency
      const updatedComments = [
        ...formik.values.comments,
        { commentText: newComment },
      ];
      formik.setFieldValue("comments", updatedComments);
      setComments(updatedComments);
      setNewComment(""); // Clear input
    }
  };
  const batchNum = localStorage.getItem("batchNum");
  let userD = JSON.parse(localStorage.getItem("userDetails"));

  const batchNumber = useSelector((state) => state.overview.batchNum);
  const batchId = useSelector((state) => state.overview.batchId);

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      boxNo: "",
      batchNo: batchNumber,
      status: null, // Initialize as null
      cleaning: false,
      quality: null,
      //  pieces: 0,
      //  grossKg: 0,
      approvedBy: null,
      temperature: null,
      files: [],
      comments: [],
      type: 1, // Add testType to initialValues
      weight: "", // Add weight to initialValues
      smell: "", // Add smell to initialValues
      quantity: "", // Add quantity to initialValues
      labelInfo: "", // Add labelInfo to initialValues
      packaging: "", // Add packaging to initialValues
      melanin: "", // Add melanin to initialValues
      bloodspot: "", // Add bloodspot to initialValues
      whiteSpots: "", // Add whitespots to initialValues
      cartilage: "", // Add cartilage to initialValues
      gaping: "", // Add gaping to initialValues
      deformed: "", // Add deformed to initialValues
      skinWounds: "", // Add skinWounds to initialValues
      description: "", // Add description to initialValues
    },
    validationSchema: Yup.lazy((values) => {
      return values?.type === 1 ? qcpSchemaTest1 : qcpSchemaTest2;
    }),
    onSubmit: async (values) => {
      setLoading(true);

      console.log("values", values, selectedFiles);
      let userD = JSON.parse(localStorage.getItem("userDetails"));
      console.log("userD", userD);

      console.log("formVlaues", selectedAttachments);

      try {
        let formValues = {
          ...values,
          comments: undefined, // Exclude comments
          files: undefined, // Exclude files
          inspectedBy: userD.firstName + " " + userD.lastName,
          approved: approvedBY ? true : false,
          boxNo: values.boxNo == "Other" ? otherBoxNo : values.boxNo,
          //  pieces: 0, // Ensure pieces is a number
          //  grossKg: 0, // Ensure grossKg is a number
          temperature: values.temperature, // Ensure temp is a number
          status: values.status,
        };

        // If type is "Fish Intake Control", include these fields

        if (values.type === 1) {
          delete formValues.melanin;
          delete formValues.bloodspot;
          delete formValues.whiteSpots;
          delete formValues.cartilage;
          delete formValues.gaping;
          delete formValues.deformed;
          delete formValues.skinWounds;
        } else if (values.type === 2) {
          delete formValues.quality;
          delete formValues.weight;
          delete formValues.smell;
          delete formValues.quantity;
          delete formValues.labelInfo;
          delete formValues.packaging;
        }

        if (isOtherSelected) {
          await handleOtherBoxNumber(); // Ensure "Other" box is added before proceeding
        }

        qcpMutation.mutate(formValues, {
          onSuccess: async (response) => {
            console.log("response", response);
            const qcp_id = response?.data; // Extract qcp_id from response
            if (!qcp_id) {
              showToast("error", "Failed to retrieve QCP ID");
              setLoading(false); // Stop loading
              return;
            }

            if (selectedAttachments?.length > 0) {
              console.log("selectedAttachments", selectedAttachments);
              for (const file of selectedAttachments) {
                const formData = new FormData();
                formData.append("QCPId", qcp_id); // Attach qcp_id to each file
                formData.append("File", file); // Attach the file

                try {
                  await new Promise((resolve, reject) => {
                    fileUploadMutation.mutate(formData, {
                      onSuccess: () => {
                        console.log(`Image ${file.name} uploaded successfully`);
                        resolve();
                      },
                      onError: (error) => {
                        console.error(
                          `Error uploading image ${file.name}:`,
                          error
                        );
                        showToast(
                          "error",
                          `Failed to upload image ${file.name}`
                        );
                        reject(error);
                      },
                    });
                  });
                } catch (error) {
                  console.error(
                    "Stopping further uploads due to error:",
                    error
                  );
                  break; // Stop further uploads if an error occurs
                }
              }
            }

            // Handle image upload sequentially
            if (selectedFiles.length > 0) {
              console.log("selectedFiles", selectedFiles);
              for (const file of selectedFiles) {
                const formData = new FormData();
                formData.append("QCPId", qcp_id); // Attach qcp_id to each file
                formData.append("File", file); // Attach the file

                try {
                  await new Promise((resolve, reject) => {
                    imageUploadMutation.mutate(formData, {
                      onSuccess: () => {
                        console.log(`Image ${file.name} uploaded successfully`);
                        resolve();
                      },
                      onError: (error) => {
                        console.error(
                          `Error uploading image ${file.name}:`,
                          error
                        );
                        showToast(
                          "error",
                          `Failed to upload image ${file.name}`
                        );
                        reject(error);
                      },
                    });
                  });
                } catch (error) {
                  console.error(
                    "Stopping further uploads due to error:",
                    error
                  );
                  break; // Stop further uploads if an error occurs
                }
              }
            }

            // Handle comments upload
            if (comments?.length > 0) {
              const commentsPayload = {
                addQCPCommentsRequest: comments.map((comment) => ({
                  qcP_ID: qcp_id,
                  commentText: comment.commentText,
                })),
              };
              console.log("commentsPayload", commentsPayload);
              commentsMutation.mutate(commentsPayload, {
                onSuccess: () => {
                  console.log("Comments added successfully");
                },
                onError: (error) => {
                  console.error("Error adding comments:", error);
                  showToast("error", "Failed to add comments");
                },
              });
            }

            // Show success toast and stop loading after all operations
            showToast("success", "QCP added successfully");

            if (formik.values.type === 1) {
              // formik.values.noBrokenGlass = null;
              // formik.values.noLooseMetalFragments = null;
              // formik.values.type = 2;
              formik.setValues({
                batchNo: formValues.batchNo,

                quality: "",
                weight: "",
                smell: "",
                quantity: "",
                labelInfo: "",
                packaging: "",
                temperature: null,
                comments: [],
                type: 2,
              });
            
              setComments([]);
              setSelectedFiles([]);
              setUploadedFiles([]);
              setSelectedAttachments([]);
              setAttachmentUploaderKey(0);
              setOtherBoxNo("")
              setBatchTrigger(Date.now())
              // setNewComments([]);
            }

            console.log("kkkkkkkkkkkk", formValues.batchNo, batchNum, batchNo)

            if (formik.values.type === 2) {
              formik.setValues({
                batchNo: formValues.batchNo,
                melanin: "",
                bloodspot: "",
                whiteSpots: "",
                cartilage: "",
                gaping: "",
                deformed: "",
                skinWounds: "",
                temperature: null,
                comments: [],
                type: 2,
              });
          
              setComments([]);
              setSelectedFiles([]);
              setUploadedFiles([]);
              setSelectedAttachments([]);
              setAttachmentUploaderKey(0);
              setOtherBoxNo("")
              setBatchTrigger(Date.now())
              // setNewComments([]);
            }

            if (count + 1 === 2) {
              navigate("/quality/fillet/qcp");
            } else {
              setCount(count + 1);
            }

            setLoading(false);

            // setTimeout(() => {
            //   navigate("/quality/fillet/qcp");
            //   setLoading(false); // Stop loading
            // }, 2000);
          },
          onError: (error) => {
            setLoading(false);
            console.error("Error submitting QCP data:", error);
            showToast(
              "error",
              error?.response?.data?.errors[0]?.errorMessageEn ||
              "Failed to submit QCP data"
            );
          },
        });
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        showToast("error", "Failed to submit QCP Inspect");
      }
    },
  });

  // Update formik status value when qcpStatus data is loaded
  // React.useEffect(() => {
  //   if (qcpStatus?.data?.length > 0 && !formik.values.status) {
  //     // Only set default if status is not already set
  //     formik.setFieldValue("status", null); // Ensure status is not preselected
  //   }
  // }, [qcpStatus]);

  console.log(formik.values.comments);

  const boxMutation = usePost("BoxesAdd", QCP_API.addBoxes); // Use usePostFormData
  console.log("values", formik.errors, formik.touched);
  const [batchNo, setBatchNo] = useState(null);
  const [batchTrigger, setBatchTrigger] = useState(Date.now()); // Use timestamp as a trigger

  const { data: boxNumbersData } = useFetch(
    batchNo ? `getBoxnumbers-${batchTrigger}` : null, // Include trigger in the key
    QCP_API.getBoxNumber,
    batchNo ? { batchNo, PageNo: 0, PageSize: 1000 } : undefined
  );

  // Update batchNo and trigger API call
  const handleBatchNoChange = (value) => {
    setBatchNo(value);
    setBatchTrigger(Date.now()); // Update timestamp to force API call
  };

  const [boxNo, setBoxNo] = useState(null); // Track selected box number
  const [isOtherSelected, setIsOtherSelected] = useState(false); // Track if "Other" is selected
  const [otherBoxNo, setOtherBoxNo] = useState(""); // Track input for "Other" box number

  const handleOtherBoxNumber = async () => {
    if (otherBoxNo.trim() !== "") {
      const payload = {
        boxNo: otherBoxNo,
        batchNo,
        // quality: "",
        // grossKg:  0, // Use form values
        // pieces: 0,  // Use form values
        temp: Number(formik.values.temperature), // Use form valuesnat
      };
      console.log("payload", payload);
      try {
        await new Promise((resolve, reject) => {
          boxMutation.mutate(payload, {
            onSuccess: () => {
              console.log("Box added successfully");
              setBoxNo(otherBoxNo); // Update boxNo state
              resolve();
            },
            onError: (error) => {
              console.error("Error adding box:", error);
              showToast("error", "Failed to add box");
              reject(error);
            },
          });
        });
      } catch (error) {
        console.error("Error in handleOtherBoxNumber:", error);
      }
    }
  };

  const { data: batchDataBox } = useFetch(
    boxNo ? "getBatchcboxdata" : null,
    QCP_API.getBoxData,
    boxNo ? { BoxShortNO: boxNo, BatchNo: batchNo } : undefined
  );
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const handleFileChange = (e) => {
    const files = e.value;
    const filePreviews = files.map((file) => ({
      name: file.name,
      size: file.size, // Include file size
      url: URL.createObjectURL(file), // Generate a preview URL for the file
      status: "pending", // Initial status
    }));

    setSelectedFiles(files); // Store selected files for upload
    setUploadedFiles(filePreviews); // Update preview list
  };

  const [selectedAttachments, setSelectedAttachments] = useState([]); // Store selected attachments
  const [uploadedAttachments, setUploadedAttachments] = useState([]); // Store uploaded attachment objects
  const [attachmentUploaderKey, setAttachmentUploaderKey] = useState(0); // Key to force re-render

  const handleAttachmentsChange = (e) => {
    const files = e.value;
    const attachmentDetails = files.map((file) => ({
      name: file.name,
      size: file.size, // Include file size
      status: "pending", // Initial status
    }));

    setSelectedAttachments(files); // Store selected files for upload
    setUploadedAttachments(attachmentDetails); // Update preview list
  };

  const handleDeleteAttachment = (index) => {
    setUploadedAttachments((prev) => prev.filter((_, i) => i !== index));
    setSelectedAttachments((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setAttachmentUploaderKey((k) => k + 1); // Force FileUploader to re-render
      return updated;
    });
  };

  const handleDeleteComment = (commentIndex) => {
    const updatedComments = comments.filter(
      (_, index) => index !== commentIndex
    );
    setComments(updatedComments);
    formik.setFieldValue("comments", updatedComments); // Update formik state
  };

  const handleDeleteImage = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setFileUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };

  useEffect(() => {
    let bNum = localStorage.getItem("batchNum");
    if (bNum && bNum !== "undefined") {
      formik.setFieldValue("batchNo", bNum);
      setBatchNo(bNum);
    } else {
      formik.setFieldValue("batchNo", "");
      setBatchNo(null);
    }
  }, []);

  console.log("batchDataBox", batchDataBox);

  return (
    <>
      <Toast
        visible={visible}
        message={toastMessage}
        type={toastType} // success, error, warning, info
        displayTime={2000} // 3 seconds
        onHiding={() => setVisible(false)}
        position={{ my: "top right", at: "top right", offset: "10 10" }}
      />

      <form onSubmit={formik.handleSubmit}>
        <p className="font-medium text-xl">Box Inspect Test</p>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-5 lg:space-y-0 space-y-3">
          <div className="border rounded border-gray-50 p-4 dark-bg">
            <div className="w-full flex items-center mb-2">
              <p className="whitespace-nowrap text-xl font-medium">Add Info:</p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="flex lg:flex-row flex-col lg:items-center items-start space-y-2 space-x-0 lg:space-x-12 lg:space-y-0 mb-4">
              <label className="text-sm relative font-bold ">
                <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                  *
                </span>
                Test Type
              </label>
              <RadioGroup
                items={[
                  { id: 1, text: "Fish Intake Control" },
                  { id: 2, text: "Fillet Control 100" },
                ]}
                valueExpr="id"
                displayExpr="text"
                layout="horizontal"
                value={formik.values.type}
                onValueChanged={(e) => formik.setFieldValue("type", e.value)}
                isValid={!formik.errors.type || !formik.touched.type}
                validationError={
                  formik.errors.type ? { message: formik.errors.type } : null
                }
              />
            </div>
            <div className="block lg:grid lg:grid-cols-2 space-y-4 lg:space-y-0 gap-4">
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Batch No.
                </label>
                <TextBox
                  placeholder="Enter Batch No..."
                  value={formik.values.batchNo}
                  onValueChange={(value) => {
                    formik.setFieldValue("batchNo", value); // Ensure formik state is updated
                    handleBatchNoChange(value); // Call the new handler
                  }}
                />
                {formik.touched.batchNo && formik.errors.batchNo && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.batchNo}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Box No.
                </label>
                <SelectBox
                  dataSource={[
                    ...(boxNumbersData?.data || []),
                    { boxNo: "Other" },
                  ]} // Add "Other" option
                  displayExpr="boxNo"
                  valueExpr="boxNo"
                  value={formik.values.boxNo}
                  onValueChanged={(e) => {
                    if (e.value === "Other") {
                      setIsOtherSelected(true); // Show input field for "Other"
                      formik.setFieldValue("boxNo", "Other"); // Set formik value to "Other"
                    } else {
                      setIsOtherSelected(false); // Hide input field for "Other"
                      formik.setFieldValue("boxNo", e.value);
                      setBoxNo(e.value);
                    }
                  }}
                  placeholder="Select a box number"
                // isValid={!formik.errors.boxNo || !formik.touched.boxNo}
                // validationError={
                //   formik.errors.boxNo
                //     ? { message: formik.errors.boxNo }
                //     : null
                // }
                />
                {formik.touched.boxNo && formik.errors.boxNo && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.boxNo}
                  </div>
                )}
                {/* {isOtherSelected && (
                                    <div className="mt-4">
                                        <label className="text-sm mb-1">Enter New Box</label>
                                        <TextBox
                                            placeholder="Enter new box number..."
                                            value={otherBoxNo}
                                            // onFocusOut={(e) => handleOtherBoxNumber(e.value)} // Corrected syntax
                                            onValueChanged={(e) => {
                                                setOtherBoxNo(e.value); // Update state on change
                                            }}
                                        />
                                    </div>
                                )} */}
              </div>
              {isOtherSelected && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Enter New Box
                  </label>
                  {/* <label className="text-sm mb-1">Enter New Box</label> */}
                  <TextBox
                    placeholder="Enter new box number..."
                    value={otherBoxNo}
                    // onFocusOut={(e) => handleOtherBoxNumber(e.value)} // Corrected syntax
                    onValueChanged={(e) => {
                      setOtherBoxNo(e.value); // Update state on change
                    }}
                  />
                </div>
              )}
              {/* <div className="lg:block lg:space-y-3 flex space-x-3 lg:space-x-0 w-1/2">
                                    <label className="text-sm mb-0 block">Cleaning</label>
                                    <CheckBox text="Yes" value={formik.values.cleaning} onValueChanged={(e) => formik.setFieldValue("cleaning", e.value)} />
                                </div> */}
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Status
                </label>
                <SelectBox
                  dataSource={qcpStatus?.data || []} // Use qcpStatus data
                  displayExpr="description" // Display the description field
                  valueExpr="orderStatusId" // Use orderStatusId as the value
                  value={formik.values.status} // Bind to formik's status field
                  onValueChanged={(e) =>
                    formik.setFieldValue("status", e.value)
                  } // Update formik value
                  placeholder="Select a status"
                // isValid={!(formik.errors.status && formik.touched.status)} // Validation check
                // validationError={
                //   formik.errors.status
                //     ? { message: formik.errors.status }
                //     : null
                // }
                />
                {formik.touched.status && formik.errors.status && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.status}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Performed by
                </label>

                <TextBox
                  disabled={true}
                  value={userDetails?.firstName + " " + userDetails?.lastName}
                  defaultValue={
                    userDetails?.firstName + " " + userDetails?.lastName
                  }
                  onValueChanged={(e) =>
                    formik.setFieldValue("inspectedBy", e.value)
                  }
                // isValid={!(formik.errors.inspectedBy && formik.touched.inspectedBy)}
                // validationError={formik.errors.inspectedBy ? { message: formik.errors.inspectedBy } : null}
                />
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Approved by
                </label>
                <SelectBox
                  dataSource={approvedBY?.data || []}
                  displayExpr={(item) =>
                    item
                      ? item.firstName
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")
                      : ""
                  } // Capitalize the first letter of each word
                  valueExpr="firstName"
                  value={formik.values.approvedBy}
                  onValueChanged={(e) =>
                    formik.setFieldValue("approvedBy", e.value)
                  }
                  // isValid={
                  //   !(formik.errors.approvedBy && formik.touched.approvedBy)
                  // }
                  // validationError={
                  //   formik.errors.approvedBy
                  //     ? { message: formik.errors.approvedBy }
                  //     : null
                  // }
                  placeholder="Select an option"
                />
                {formik.touched.approvedBy && formik.errors.approvedBy && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.approvedBy}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Description
                </label>

                <div className=" w-full">
                  <TextBox
                    value={formik.values.description} // Use formik value or fallback to batchDataBox
                    placeholder="Enter description..."
                    width="100%"
                    onValueChanged={(e) =>
                      formik.setFieldValue("description", e.value)
                    } // Ensure decimal input
                  // isValid={
                  //   !(formik.errors.description && formik.touched.description)
                  // } // Show validation only if touched
                  // validationError={
                  //   formik.errors.description
                  //     ? { message: formik.errors.description }
                  //     : null
                  // }
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {formik.errors.description}
                    </div>
                  )}
                </div>
              </div>
              {formik.values.type === 1 && (
                <>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Quality
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.quality}
                      onValueChanged={(e) =>
                        formik.setFieldValue("quality", e.value)
                      }
                    // isValid={
                    //   !(formik.errors.quality && formik.touched.quality)
                    // }
                    // validationError={
                    //   formik.errors.quality
                    //     ? { message: formik.errors.quality }
                    //     : null
                    // }
                    />
                    {formik.touched.quality && formik.errors.quality && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.quality}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Weight
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.weight}
                      onValueChanged={(e) =>
                        formik.setFieldValue("weight", e.value)
                      }
                    // isValid={!(formik.errors.weight && formik.touched.weight)}
                    // validationError={
                    //   formik.errors.weight
                    //     ? { message: formik.errors.weight }
                    //     : null
                    // }
                    />
                    {formik.touched.weight && formik.errors.weight && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.weight}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Smell
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.smell}
                      onValueChanged={(e) =>
                        formik.setFieldValue("smell", e.value)
                      }
                    // isValid={!(formik.errors.smell && formik.touched.smell)}
                    // validationError={
                    //   formik.errors.smell
                    //     ? { message: formik.errors.smell }
                    //     : null
                    // }
                    />
                    {formik.touched.smell && formik.errors.smell && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.smell}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Quantity
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.quantity}
                      onValueChanged={(e) =>
                        formik.setFieldValue("quantity", e.value)
                      }
                    // isValid={
                    //   !(formik.errors.quantity && formik.touched.quantity)
                    // }
                    // validationError={
                    //   formik.errors.quantity
                    //     ? { message: formik.errors.quantity }
                    //     : null
                    // }
                    />
                    {formik.touched.quantity && formik.errors.quantity && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.quantity}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Label Info
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.labelInfo}
                      onValueChanged={(e) =>
                        formik.setFieldValue("labelInfo", e.value)
                      }
                    // isValid={
                    //   !(formik.errors.labelInfo && formik.touched.labelInfo)
                    // }
                    // validationError={
                    //   formik.errors.labelInfo
                    //     ? { message: formik.errors.labelInfo }
                    //     : null
                    // }
                    />
                    {formik.touched.labelInfo && formik.errors.labelInfo && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.labelInfo}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Packaging
                    </label>
                    <RadioGroup
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.packaging}
                      onValueChanged={(e) =>
                        formik.setFieldValue("packaging", e.value)
                      }
                    // isValid={
                    //   !(formik.errors.packaging && formik.touched.packaging)
                    // }
                    // validationError={
                    //   formik.errors.packaging
                    //     ? { message: formik.errors.packaging }
                    //     : null
                    // }
                    />
                    {formik.touched.packaging && formik.errors.packaging && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.packaging}
                      </div>
                    )}
                  </div>
                </>
              )}

              {formik.values.type === 2 && (
                <>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Melanin
                    </label>
                    <TextBox
                      placeholder="Enter Melanin..."
                      value={formik.values.melanin}
                      mode="number"
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("melanin", value);
                      }}
                    // isValid={
                    //   !(formik.errors.melanin && formik.touched.melanin)
                    // }
                    // validationError={
                    //   formik.errors.melanin
                    //     ? { message: formik.errors.melanin }
                    //     : null
                    // }
                    />
                    {formik.touched.melanin && formik.errors.melanin && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.melanin}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Blood Spot
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter Blood Spot..."
                      value={formik.values.bloodspot}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("bloodspot", value);
                      }}
                    // isValid={
                    //   !(formik.errors.bloodspot && formik.touched.bloodspot)
                    // }
                    // validationError={
                    //   formik.errors.bloodspot
                    //     ? { message: formik.errors.bloodspot }
                    //     : null
                    // }
                    />
                    {formik.touched.bloodspot && formik.errors.bloodspot && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.bloodspot}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      White Spots
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter White Spots..."
                      value={formik.values.whiteSpots}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("whiteSpots", value);
                      }}
                    // isValid={
                    //   !(formik.errors.whiteSpots && formik.touched.whiteSpots)
                    // }
                    // validationError={
                    //   formik.errors.whiteSpots
                    //     ? { message: formik.errors.whiteSpots }
                    //     : null
                    // }
                    />
                    {formik.touched.whiteSpots && formik.errors.whiteSpots && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.whiteSpots}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Cartilage
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter Cartilage..."
                      value={formik.values.cartilage}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("cartilage", value);
                      }}
                    // isValid={
                    //   !(formik.errors.cartilage && formik.touched.cartilage)
                    // }
                    // validationError={
                    //   formik.errors.cartilage
                    //     ? { message: formik.errors.cartilage }
                    //     : null
                    // }
                    />
                    {formik.touched.cartilage && formik.errors.cartilage && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.cartilage}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Gaping
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter Gaping..."
                      value={formik.values.gaping}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("gaping", value);
                      }}
                    // isValid={!(formik.errors.gaping && formik.touched.gaping)}
                    // validationError={
                    //   formik.errors.gaping
                    //     ? { message: formik.errors.gaping }
                    //     : null
                    // }
                    />
                    {formik.touched.gaping && formik.errors.gaping && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.gaping}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Deformed
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter Deformed..."
                      value={formik.values.deformed}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("deformed", value);
                      }}
                    // isValid={
                    //   !(formik.errors.deformed && formik.touched.deformed)
                    // }
                    // validationError={
                    //   formik.errors.deformed
                    //     ? { message: formik.errors.deformed }
                    //     : null
                    // }
                    />
                    {formik.touched.deformed && formik.errors.deformed && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.deformed}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Skin Wounds
                    </label>
                    <TextBox
                      mode="number"
                      placeholder="Enter Skin Wounds..."
                      value={formik.values.skinWounds}
                      onValueChanged={(e) => {
                        const value = e.value < 0 ? "" : e.value; // Set to empty string if negative
                        formik.setFieldValue("skinWounds", value);
                      }}
                    // isValid={
                    //   !(formik.errors.skinWounds && formik.touched.skinWounds)
                    // }
                    // validationError={
                    //   formik.errors.skinWounds
                    //     ? { message: formik.errors.skinWounds }
                    //     : null
                    // }
                    />
                    {formik.touched.skinWounds && formik.errors.skinWounds && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.skinWounds}
                      </div>
                    )}
                  </div>
                </>
              )}
              {/* <div>
                                <label className="text-sm mb-1 relative"><span className='text-red-500 text-lg absolute top-[-4px] right-[-12px]'>*</span>Pieces</label>

                                <div className=" w-full">
                                    <TextBox
                                        value={formik.values.pieces ?? batchDataBox?.data?.pieces} // Use formik value or fallback to batchDataBox
                                        placeholder="Enter Pieces..."
                                        width="100%"
                                        onValueChanged={(e) => formik.setFieldValue("pieces", e.value)} // Ensure decimal input
                                        isValid={!(formik.errors.pieces && formik.touched.pieces)} // Show validation only if touched
                                        validationError={formik.errors.pieces ? { message: formik.errors.pieces } : null}

                                    />
                                </div>
                            </div> */}

              {/* <div>
                                <label className="text-sm mb-1 relative"><span className='text-red-500 text-lg absolute top-[-4px] right-[-12px]'>*</span>Gross (kg)</label>

                                <div className=" w-full">
                                    <TextBox
                                        value={formik.values.grossKg ?? batchDataBox?.data?.grossKg} // Use formik value or fallback to batchDataBox
                                        placeholder="Enter Gross kg..."
                                        width="100%"
                                        onValueChanged={(e) => formik.setFieldValue("grossKg", e.value)} // Ensure decimal input
                                        isValid={!(formik.errors.grossKg && formik.touched.grossKg)} // Show validation only if touched
                                        validationError={formik.errors.grossKg ? { message: formik.errors.grossKg } : null}

                                    />
                                </div>
                            </div> */}

              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                    *
                  </span>
                  Average Temp. (°C)
                </label>

                <div className=" w-full">
                  <TextBox
                    value={
                      formik.values.temperature ??
                      batchDataBox?.data?.temperature
                    } // Use formik value or fallback to batchDataBox
                    placeholder="Enter temperature..."
                    width="100%"
                    onValueChanged={(e) =>
                      formik.setFieldValue("temperature", e.value)
                    } // Ensure decimal input
                  // isValid={
                  //   !(formik.errors.temperature && formik.touched.temperature)
                  // } // Show validation only if touched
                  // validationError={
                  //   formik.errors.temperature
                  //     ? { message: formik.errors.temperature }
                  //     : null
                  // }
                  />
                  {formik.touched.temperature && formik.errors.temperature && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {formik.errors.temperature}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="w-full flex items-center mt-4 mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Picture(s):
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
              <FileUploader
                multiple
                accept=".png, .jpg, .jpeg, .jpg, .gif, .webp, .svg"
                key={fileUploaderKey}
                value={selectedFiles}
                showFileList={false}
                // uploadMode="useButtons" // Automatically upload files when selected
                // uploadUrl="http://localhost:5000/upload" // Replace with your API endpoint
                onValueChanged={handleFileChange} // Triggered when files are selected
              />
              {uploadedFiles.length > 0 && (
                <ul className="grid grid-cols-3 gap-4">
                  {uploadedFiles.map((file, index) => (
                    <li key={index} className="text-sm relative">
                      <img
                        src={file.url}
                        alt={file.name}
                        className="w-full h-24 object-cover rounded border"
                      />
                      <p className="text-xs text-center mt-1 break-words mb-0">
                        {file.name}
                      </p>
                      <button
                        type="button"
                        className="absolute top-1 right-1 text-red-700 text-xs rounded-full p-1"
                        onClick={() => handleDeleteImage(index)}
                      >
                        ✕
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="w-full flex items-center mt-4 mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Attachment(s):
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
              <FileUploader
                multiple
                accept=".pdf, .docx, .xlsx .doc, .pptx, .txt, .ppt, .xls, .csv, .zip, .rar"
                key={attachmentUploaderKey}
                value={selectedAttachments}
                showFileList={false}
                onValueChanged={handleAttachmentsChange} // Triggered when files are selected
              />
              {uploadedAttachments.length > 0 && (
                <ul className="space-y-2 ps-0 flex items-center justify-center flex-column mb-0">
                  {uploadedAttachments.map((file, index) => (
                    <li
                      key={index}
                      className="text-sm flex items-center space-x-2 rounded-md border p-2"
                    >
                      <span>{file.name}</span>
                      <button
                        type="button"
                        className="text-red-700 text-xs rounded-full p-1"
                        onClick={() => handleDeleteAttachment(index)}
                      >
                        ✕
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="border rounded border-gray-50 dark-bg p-4 flex flex-col">
            <div className="w-full flex items-center mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Comments:
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="max-h-full overflow-y-auto pr-2 custom-scrollbar space-y-2 mb-4">
              {comments?.map((comment, index) => (
                <div
                  key={index}
                  className="bg-gray-100 dark-bg hover:bg-gray-200 hover:cursor-pointer rounded px-3 py-2 border"
                >
                  <div className="flex items-center justify-end space-x-5">
                    <p className="text-xs mb-0 whitespace-nowrap">
                      {new Date(currentDate).toISOString().split("T")[0]}{" "}
                      {/* Format date as yyyy-m-dd */}
                    </p>
                    <button
                      type="button"
                      className="text-red-700 ml-10 text-xs"
                      onClick={() => handleDeleteComment(index)}
                    >
                      ✕
                    </button>
                  </div>
                  <p className="break-words mt-2">{comment.commentText}</p>
                </div>
              ))}
            </div>
            <div className="mt-auto">
              <TextArea
                placeholder="Type comment..."
                height={100}
                maxLength={123}
                stylingMode="outlined"
                mode="multiline"
                value={newComment} // Controlled input
                onValueChanged={(e) => setNewComment(e.value)} // Only update newComment
              />
              <Button
                className="mt-2"
                icon="plus"
                text="Add more comment"
                stylingMode="text"
                onClick={handleAddComment} // Call function on click
              />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end mt-6">
          <Button
            onClick={() => {
              navigate("/quality/fillet/qcp");
            }}
            className="me-3"
            width={100}
            text="Cancel"
            type="normal"
            stylingMode="outlined"
          />
          <Button
            text={loading ? "Saving..." : "Save"} // Change text when loading
            width={100}
            stylingMode="contained"
            type="default"
            disabled={loading}
            useSubmitBehavior
          />
        </div>
      </form>
    </>
  );
}
